import { ModelRow } from "@mcleod/core";
import { SecondaryFilterProps } from "./planning/FilterPanel";

export class TariffRegionUtil {

    static readonly ACTIVE_ZIP: SecondaryFilterProps = {
        id: "active",
        caption: "Active",
        filter: (row: ModelRow) => {
            const currentTimestamp = new Date();
            currentTimestamp.setHours(23,59,59);
            const expireTimestamp = new Date(row.get("expire_timestamp"));
            return row.get("expire_timestamp") == null || currentTimestamp < expireTimestamp;
        }
    }

    static readonly EXPIRED_ZIP: SecondaryFilterProps = {
        id: "expired",
        caption: "Expired",
        filter: (row: ModelRow) => {
            const currentTimestamp = new Date();
            currentTimestamp.setHours(23,59,59);
            const expireTimestamp = row.get("expire_timestamp");
            const zipCode = row.get("fd_zipcode");
            const expireDate = new Date(expireTimestamp);
            const isExpired = expireTimestamp != null && currentTimestamp >= expireDate
            return isExpired;
        }
    }

    static readonly ACTIVE_LOC: SecondaryFilterProps = {
        id: "active",
        caption: "Active",
        filter: (row: ModelRow) => {
            const currentTimestamp = new Date();
            currentTimestamp.setHours(23,59,59);
            const expireTimestamp = new Date(row.get("expiration_date"));
            return row.get("expiration_date") == null || currentTimestamp < expireTimestamp;
        }
    }

    static readonly EXPIRED_LOC: SecondaryFilterProps = {
        id: "expired",
        caption: "Expired",
        filter: (row: ModelRow) => {
            const currentTimestamp = new Date();
            currentTimestamp.setHours(23,59,59);
            const expireTimestamp = new Date(row.get("expiration_date"));
            const isExpired = row.get("expiration_date") != null && currentTimestamp >= expireTimestamp
            return isExpired;
        }
    }

    public static getZipCodesSecondaryFilter(): SecondaryFilterProps[] {
        return [TariffRegionUtil.ACTIVE_ZIP, TariffRegionUtil.EXPIRED_ZIP];
    }

    public static getLocationsSecondaryFilter(): SecondaryFilterProps[] {
        return [TariffRegionUtil.ACTIVE_LOC, TariffRegionUtil.EXPIRED_LOC];
    }

    public static getImageTooltip(numberOfRowsSelected: number): string {
        return numberOfRowsSelected === 0 ? TariffRegionUtil.defaultImageTooltip() : (numberOfRowsSelected === 1  ? '1 row selected to set expiration' : numberOfRowsSelected + ' rows selected to set expiration');
    }

    public static defaultImageTooltip(): string {
        return 'Select one or more rows to set expiration.';
    }
}
